// Close all forms
export function closeAllForms() {
  const formsIds = [
    'addAccommodationForm',
    'addAccommodationBlockForm',
    'addTourForm',
    'addTourBlockForm',
    'updateAccommodationForm',
    'updateAccommodationBlockForm',
    'updateTourForm',
    'updateTourBlockForm',
    'addProductForm',
  ];

  formsIds.forEach((formId) => {
    const formElement = document.getElementById(formId);
    if (formElement) {
      // Check if the form element exists
      formElement.classList.remove('open');
    }
  });

  // Reset z-index for all booking items
  const bookingItems = document.querySelectorAll(
    '.calendar-tour-booking-item, .calendar-accomm-booking-item',
  );
  bookingItems.forEach((item) => {
    // Reset the z-index to its original value
    item.style.zIndex = item.getAttribute('data-original-z-index') || 'auto';
    item.removeAttribute('data-original-z-index');
  });

  // Remove 'selected' class from all booking items
  const selectedItems = document.querySelectorAll(
    '.calendar-tour-booking-item.selected, .calendar-accomm-booking-item.selected',
  );
  selectedItems.forEach((item) => {
    item.classList.remove('selected');
  });
}
